import React, { Fragment, useEffect, useState } from "react";
import { SubNav, Row, useAPI, Grid } from "components/lib";
import { useParams } from "react-router-dom";
import moment from "moment-timezone";
import { buildVerificationNavBarItems } from "./nav-bar-items";
import { isScreeningRow, formatScreenedHeader } from "./screening-row";
import { ScreeningPdfButton } from "./screening-pdf-button";

const Axios = require("axios");

export function AdverseMediaView(props) {
  const params = useParams();
  const verification = useAPI(`/api/verification/${params.id}`);
  const accountInfo = useAPI("/api/account");
  const tranche2Permission = useAPI("/api/integration/tranche2/settings/can-complete");
  const canCompleteRiskAssessment = tranche2Permission?.data?.can_complete === true;
  console.log("Adverse Media View", verification, accountInfo);
  const [navBarItems, setNavBarItems] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  // `verification` is the useAPI wrapper; the row itself sits inside it.
  const row = verification?.data?.verification?.[0];
  const screeningRow = !!row && isScreeningRow(row.type);

  // Name for the Google-results heading. A manual screening row has no
  // result_info, so it falls back to the typed name (the server's
  // getGoogleSearch searches the same name). Every other row is unchanged.
  function googleHeadingName(personField, rowField) {
    const personValue = row?.result_info?.verification?.person?.[personField];
    return screeningRow ? personValue || row[rowField] : personValue;
  }

  function getAdverseMediaResults(adverseMediaResults) {
    if (adverseMediaResults?.status?.serviceSuspected === false || !adverseMediaResults) {
      return <p>Adverse Media Resuts: No matches found</p>;
    } else {
      const adverseMediaArray = adverseMediaResults.data.map((r) => (
        <>
          <p className="text-sg-blue">
            <a href={`${r?.url}`}>
              <strong>{r?.title}</strong>
            </a>
          </p>
          <p>Text: {r?.text}</p>
          <p>
            <br />
          </p>
        </>
      ));

      const sanctionsMarkup = [];
      sanctionsMarkup.push(
        <div>
          <br />
          <p>
            Adverse Media Results: <strong>Possible Matches found</strong>
          </p>
          <br />
        </div>
      );

      adverseMediaArray.forEach((sanction, index) => {
        sanctionsMarkup.push(<div key={index}>{sanction}</div>);
      });

      return sanctionsMarkup;
    }
  }

  useEffect(() => {
    if (!verification.loading && verification.data) {
      setNavBarItems(
        buildVerificationNavBarItems(
          verification.data.verification[0],
          params,
          { canCompleteRiskAssessment }
        )
      );
    }
  }, [verification, canCompleteRiskAssessment]);

  useEffect(() => {
    async function fetchGoogleSearchResults() {
      if (accountInfo?.data?.sanctions_settings?.enable_google_search) {
        try {
          const tz = moment.tz.guess();          // e.g. "Australia/Melbourne"
          const countries = moment.tz.zone(tz).countries();  
          const countryCode = countries?.[0] || "us";      // "AU"
          const locale = navigator.language || navigator.userLanguage;
          const [language, region] = locale.split('-');

          const response = await Axios.get(
            `/api/verification/google-search/${params.id}?lang=${language}&region=${countryCode.toLowerCase()}` // Adjust the endpoint as needed
          );
          console.log("Google Search Results:", response.data);
          setSearchResults(response.data.data || []);
        } catch (error) {
          console.error("Error fetching Google search results:", error);
        }
      }
    }

    if (accountInfo?.data?.sanctions_settings?.enable_google_search){
      fetchGoogleSearchResults();
    } 
  }, [accountInfo]);

  return (
    <Fragment>
      <Grid>
        <Row>
          <SubNav items={navBarItems} />
          {/* Manual screening rows only, whether or not Google search is on.
              The report holds the stored results only, never Google's. */}
          {screeningRow && (
            <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
              <p className="font-semibold text-slate-900">
                {formatScreenedHeader(row, { withDob: false })}
              </p>
              <ScreeningPdfButton row={row} check="adverse_media" />
            </div>
          )}
          {verification?.data?.verification?.[0].adverse_media_results &&
            getAdverseMediaResults(
              verification?.data?.verification?.[0]?.adverse_media_results
                ?.AML?.[0]
            )}
        </Row>
        {(accountInfo?.data?.sanctions_settings?.enable_google_search && searchResults?.length > 0) && (<Row>
          {/* create a return of embed of google search */}
          {/* search results in a table */}          <br />
            <>
              {console.log("Search Results:", searchResults)}
              <h1 className="text-sg-blue text-2xl font-bold text-center p-10">Google Search Results for {googleHeadingName("firstName", "first_name")} {googleHeadingName("lastName", "last_name")}</h1>
              {searchResults.map((result, index) => (
                <div key={index} className="mb-4">
                  <h3 className="text-lg font-semibold">
                    <a href={result.url} target="_blank" rel="noopener noreferrer" className="text-sg-blue hover:underline">
                      {result.title}
                    </a>
                  </h3>
                  <p>{result.snippet}</p>
               </div>
              ))}
            </>
        </Row>)}
      </Grid>
    </Fragment>
  );
}
